import React from "react";
//Mui
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

type Props = {
  title: string;
  btnText?: string;
  onClick?: () => void;
};

const PageTitle = ({ title, btnText, onClick }: Props) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="baseline"
      mb={1}
    >
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {btnText && (
        <Button
          variant="contained"
          onClick={onClick}
          startIcon={<AddIcon />}
          sx={{
            flexGrow: 0,
          }}
        >
          {btnText}
        </Button>
      )}
    </Stack>
  );
};

export default PageTitle;
